// extracted by mini-css-extract-plugin
export var parcelRow = "_sk-0";